import { useNavigate, useSearchParams } from "react-router-dom";

import HolidayDeleteForm from "features/admin/holidays/HolidayDeleteForm";
import HolidayForm from "features/admin/holidays/HolidayForm";
import HolidaysTable from "features/admin/holidays/HolidaysTable";
import Modal from "shared/components/feedback/modals/MasterModal";
import PageWrapper from "app/components/PageWrapper";

const FormPresenter = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const action = searchParams.get("action");
    const date = searchParams.get("id");

    const onClose = () => {
        navigate(".", { replace: true });
    };

    if (action === "add") {
        return (
            <Modal
                title="Add Holiday"
                onRequestClose={onClose}
                stickyAction={true}
            >
                <HolidayForm key="new" onClose={onClose} />
            </Modal>
        );
    }

    if (action === "edit") {
        return (
            <Modal
                title="Edit Holiday"
                onRequestClose={onClose}
                stickyAction={true}
            >
                <HolidayForm
                    holidayIdToEdit={date}
                    key={date}
                    onClose={onClose}
                />
            </Modal>
        );
    }

    if (action === "delete") {
        return (
            <Modal
                title="Delete Holiday"
                onRequestClose={onClose}
                stickyAction={true}
            >
                <HolidayDeleteForm
                    holidayIdToDelete={date}
                    key={date}
                    onClose={onClose}
                />
            </Modal>
        );
    }

    return <></>;
};

const Holidays = () => {
    return (
        <PageWrapper
            title="Holidays"
            menuOptions={[{ children: "Admin", to: "/admin" }]}
        >
            <FormPresenter />
            <HolidaysTable />
        </PageWrapper>
    );
};

export default Holidays;
